import axios from "axios"

export interface InterfaceLanguageResponse {
    language: string
}

export async function getInterfaceLanguage(): Promise<InterfaceLanguageResponse> {
    const { data } = await axios.get<InterfaceLanguageResponse>("/user/language")
    return data
}

export async function setInterfaceLanguage(language: string): Promise<InterfaceLanguageResponse> {
    const { data } = await axios.put<InterfaceLanguageResponse>("/user/language", { language })
    return data
}
